import validator from "validator";
import checkUtente from "../services/checkUtente";
import getPresenze from "../services/getPresenze";
import getChiusura from "../services/getChiusura";
import getLezioni from "../services/getLezioni";
import getStudenti from "../services/getStudenti";

import moment from "moment";
import Cookies from "universal-cookie";
import Constants from "./consts";

export default class Utils {
  /**
   * Normalizza una stringa di id corsi gestendo TUTTI i formati storici:
   * separatore "," oppure ";", spazi, e id finale senza separatore.
   * Es: "5;12;30;" / "5,12,30" / "5; 12 ;30" -> ["5","12","30"]
   */
  static parseCorsi(str) {
    return (str || "")
      .toString()
      .split(/[,;]/)
      .map((s) => s.trim())
      .filter(Boolean);
  }

  /**
   * True se la stringa di corsi contiene l'id indicato (match esatto, no sottostringa).
   */
  static hasCorso(corsiStr, id) {
    return Utils.parseCorsi(corsiStr).includes(String(id).trim());
  }

  static disallowConcurrency(fn) {
    let richiestaInCorsoPromise = Promise.resolve();

    return async (...args) => {
      await richiestaInCorsoPromise;
      richiestaInCorsoPromise = richiestaInCorsoPromise.then(() => fn(...args));

      return richiestaInCorsoPromise;
    };
  }

  static async filterLessonsWithoutRegisters(lessons) {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    var studenti = await getStudenti(username, token);

    var compareData = moment();
    var compareDataBegin = moment();

    compareData = compareData.add(-1, "days");
    compareData.hour(23);
    compareData.minutes(59);

    compareDataBegin = compareDataBegin.add(-8, "days");
    compareDataBegin.hour(23);
    compareDataBegin.minutes(59);

    var retList = [];
    for (var l of lessons) {
      var data = moment(l.data, "yyyy-MM-DD HH:mm:ss");

      if (data < compareDataBegin) continue;
      if (data > compareData) continue;

      var corsi = [l.id_corso];
      for (var c of l.altri_corsi.split(";")) corsi.push(c);

      var studentiCorso = studenti.filter((s) => {
        var sCorsi = Utils.parseCorsi(s.corsi);
        return Utils.isComponentArrayMatch(corsi, sCorsi);
      });

      studentiCorso = studentiCorso.filter((s) => {
        var sCorsi = Utils.parseCorsi(s.corsi_ritiro);
        return Utils.isComponentArrayMatch(corsi, sCorsi) == false;
      });

      var presenze = await getPresenze(username, token, l.id);
      // controlla se la presenza è stata registrata per tutti gli studenti
      if (presenze.length >= studentiCorso.length) continue;

      retList.push(l);
    }

    return retList;
  }

  static isComponentArrayMatch(arr1, arr2) {
    for (var e1 of arr1) {
      if (e1 == "") continue;
      for (var e2 of arr2) {
        if (e2 == "") continue;
        if (e1 == e2) return true;
      }
    }
    return false;
  }

  static getMonthName(month) {
    if (month == 1) return "Gennaio";
    if (month == 2) return "Febbraio";
    if (month == 3) return "Marzo";
    if (month == 4) return "Aprile";
    if (month == 5) return "Maggio";
    if (month == 6) return "Giugno";
    if (month == 7) return "Luglio";
    if (month == 8) return "Agosto";
    if (month == 9) return "Settembre";
    if (month == 10) return "Ottobre";
    if (month == 11) return "Novembre";
    if (month == 12) return "Dicembre";
  }

  static checkRegisterWarningToDisplay() {
    const cookies = new Cookies();
    const lastRegisterWarningDate = cookies.get("lastRegisterWarningDate", {
      path: "/",
    });
    const registerWarningShown = cookies.get("registerWarningShown", {
      path: "/",
    });

    // Se l'avviso è già stato mostrato in questa sessione, non mostrarlo di nuovo
    if (registerWarningShown === "true") {
      return false;
    }

    if (lastRegisterWarningDate == undefined || lastRegisterWarningDate == "")
      return true;
    var dataLast = moment(lastRegisterWarningDate, "yyyy-MM-DD HH:mm:ss");
    var dataNow = moment();
    var diff = dataNow.diff(dataLast, "seconds");

    // differenza di 6 ore
    if (diff > 60 * 60 * 6) {
      return true;
    } else {
      //alert ('La differenza è di ' + diff + ' secondi');
      return false;
    }
  }

  static async checkLessonsForDay(day) {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    let lezioni = await getLezioni(username, token);

    var lezioniOutput = "";

    lezioni.forEach((l) => {
      var dataLezione = moment(l.data, "yyyy-MM-DD HH:mm:ss");
      var dataChiusura = moment(day, "DD-MM-yyyy");
      if (dataLezione.year() == dataChiusura.year())
        if (dataLezione.month() == dataChiusura.month())
          if (dataLezione.date() == dataChiusura.date()) {
            lezioniOutput +=
              l.data + " " + l.str_corso + " " + l.cognome_ins + "\n";
          }
    });

    return lezioniOutput;
  }

  static async getLessonsDuringClosure() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    let chiusure = await getChiusura(username, token);
    let lezioni = await getLezioni(username, token);

    var lezioniOutput = "";

    lezioni.forEach((l) => {
      chiusure.forEach((c) => {
        var dataLezione = moment(l.data, "yyyy-MM-DD HH:mm:ss");
        var dataChiusura = moment(c.day, "DD-MM-yyyy");
        if (dataLezione.year() == dataChiusura.year())
          if (dataLezione.month() == dataChiusura.month())
            if (dataLezione.date() == dataChiusura.date()) {
              let asd = 34;
              let dfg = asd;
              lezioniOutput +=
                l.data + " " + l.str_corso + " " + l.cognome_ins + "\n";
            }
      });
    });

    return lezioniOutput;
  }

  static updateRegisterWarningToDisplay() {
    const cookies = new Cookies();
    let startDate = moment().format("yyyy-MM-DD HH:mm:ss");
    cookies.set("lastRegisterWarningDate", startDate, { path: "/" });
    // Imposta un flag per indicare che l'avviso è stato mostrato in questa sessione
    cookies.set("registerWarningShown", "true", { path: "/" });
  }

  static resetRegisterWarningFlag() {
    const cookies = new Cookies();
    cookies.remove("registerWarningShown", { path: "/" });
  }

  static generatePassword() {
    var password = Math.random() * 8999999 + 1000000;
    password = parseInt(password);
    return password;
  }

  static checkIdsArrays(arr1, arr2) {
    var found = false;

    arr1.forEach((e1) => {
      if (e1 == "") return;
      arr2.forEach((e2) => {
        if (e2 == "") return;
        if (e1 == e2) found = true;
      });
    });

    return found;
  }

  static async generateUsername(uname, token, name, surname) {
    name = name.toLowerCase().trim();
    surname = surname.toLowerCase().trim();
    name = name.replaceAll(" ", "_");
    surname = surname.replaceAll(" ", "_");

    var username = "";
    if (name == "") username = surname;
    else if (surname == "") username = name;
    else username = name + "." + surname;

    username = username.replace(" ", ".");

    var continueVal = true;
    var count = 0;
    while (continueVal) {
      if (count > 0) username = username + count;
      var result = await checkUtente(uname, token, username);
      if (result.length > 0) count++;
      else continueVal = false;
    }
    username = username.replace("'", "");
    username = username.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    return username;
  }

  static validateEmail = (email) => {
    if (validator.isEmail(email)) {
      return true;
    } else {
      return false;
    }
  };

  static capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  static unescapeString(str) {
    if (!str) return "";

    var string = str;

    string = string.replace(/\\u00e0/g, "à");
    string = string.replace(/\\u00e8/g, "è");
    string = string.replace(/\\u00f2/g, "ò");
    string = string.replace(/\\u00ec/g, "ì");
    string = string.replace(/\\u00f9/g, "ù");
    string = string.replace(/\\u00e9/g, "é");
    string = string.replace(/\\u00e1/g, "á");
    string = string.replace(/\\u00ed/g, "í");
    string = string.replace(/\\u00f3/g, "ó");
    string = string.replace(/\\u00fa/g, "ú");
    string = string.replace(/\\u00c8/g, "È");
    string = string.replace(/\\u2019/g, "'");
    string = string.replace(/u00e0/g, "à");
    string = string.replace(/u00e8/g, "è");
    string = string.replace(/u00f2/g, "ò");
    string = string.replace(/u00ec/g, "ì");
    string = string.replace(/u00f9/g, "ù");
    string = string.replace(/u00e9/g, "é");
    string = string.replace(/u00e1/g, "á");
    string = string.replace(/u00ed/g, "í");
    string = string.replace(/u00c8/g, "È");
    string = string.replace(/u00f3/g, "ó");
    string = string.replace(/u00fa/g, "ú");
    string = string.replace(/u2019/g, "’");
    string = string.replace(/\0/g, "");
    string = string.replace(/\\n/g, "");
    string = string.replace(/\\r/g, "");
    string = string.replace(/\\b/g, "");
    string = string.replace(/\\t/g, "");
    string = string.replace(/\\z/g, "");
    string = string.replace(/\\/g, "");

    return decodeURIComponent(string);
  }

  static escapeStringNew(str) {
    if (!str) return "";
    return encodeURIComponent(str);
  }

  static unescapeStringNew(str) {
    if (!str) return "";
    return decodeURIComponent(str);
  }

  static escapeString(str) {
    if (!str) return "";

    return str.replace(/[\0\x08\x09\x1a\n\r"'\\\%]/g, function(char) {
      switch (char) {
        case "\0":
          return "\\0";
        case "\x08":
          return "\\b";
        case "\x09":
          return "\\t";
        case "\x1a":
          return "\\z";
        case "\n":
          return "\\n";
        case "\r":
          return "\\r";
        case '"':
        case "'":
        case "\\":
        case "%":
          return "\\" + char;
        default:
          return char;
      }
    });
  }

  static getHoursArray() {
    var arr = [];
    for (var i = 0; i < 24; i++) {
      arr.push(i);
    }
    return arr;
  }

  static getMinutesArray() {
    var arr = [];
    for (var i = 0; i < 60; i += 5) {
      arr.push(i);
    }
    return arr;
  }

  static roundTime(str) {
    if (str.length == 1) {
      return "0" + str;
    } else return str;
  }
}
